import { VariantType } from '@/components/Ad/Status/PaymentFlow.types';
import { AdKind } from '@/api/types/common.types';
import { AdBundle } from '@/api/types/categories.types';

export function mapVariantTypeToAdKindOrNull(variantType: VariantType) {
  if (variantType === 'vip') return AdKind.Vipped;
  if (variantType === 'featured') return AdKind.Premium;
  return null;
}

export function findMinPricePerAd(bundles?: AdBundle[]) {
  if (!bundles) return 0;

  return Math.min(...bundles.map(bundle => bundle.price / bundle.count));
}
